import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/services/common/common.service';
import { ChatService } from 'src/app/services/sockets/chat.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-advisor-chat',
  templateUrl: './advisor-chat.component.html',
  styleUrls: ['./advisor-chat.component.scss'],
})
export class AdvisorChatComponent implements OnInit {
  chatTitle = 'Advisors';
  @Input() count: number = 3;
  @Input() totalCount: number = 100;
  progressVal: number;
  strokeVal: number;
  searchAdvisor;
  content = '';
  content2 = '';
  sent = [];
  last_seen: any = '';
  last_seen1: any = '';
  received = [];
  messagedAdvisor: any = [];
  opened: boolean = false;

  title = 'Advisors List';
  searchAdvisorList: any;
  loading: boolean = false;
  userId = 999;

  dataSubscription: Subscription;
  availableData: any = [];
  // openedItems: boolean[];

  fetchedMessages: any = [];
  fetchedMessages2: any = [];
  participantName: any = '';
  participantName1: any = '';

  receivedId: any;
  receivedId2: any;
  participant_window: boolean = false;
  participant_window2: boolean = false;
  messageContentExtender: boolean = false;
  messageContentExtender2: boolean = false;
  getStatusTime: any;
  presentTime: any;
  media_id: any;
  active_now: boolean = false;
  active_now1: boolean = false;
  show_details: boolean = false;
  show_different_dates: any = [];
  show_different_dates2: any = [];
  selected_doc_type = {
    file: '',
    file_name: '',
  };
  show_timestamp: any = [];
  show_timestamp2: any = [];
  show_dates: any = '';
  baseDownloadUrl: any = '';
  participant_profile_picture: any;
  participant_profile_picture1: any;
  openParticipants: any[] = [];
  participantData: any;
  participantData2: any;
  firstWindowMessages: any = [];
  secondWindowMessages: any = [];
  user_details: any;
  profile_image: any;
  subscription1: Subscription;
  subscription2: Subscription;
  messages_count: any = 0;
  messages_count2: any = 0;
  initialPageNumberForWindow1 = 1;
  currentPageNumberForWindow1 = 1;
  initialPageNumberForWindow2 = 1;
  currentPageNumberForWindow2 = 1;
  scroll_page_window1: any;
  previousScrollHeight2: number = 0;
  message_sender_type: any = '';
  search_index: any;
  filteredData: any = [];
  selected_advisor: any;
  isSearched: boolean = false;
  private chatSubscription: Subscription;
  messageLoading: boolean = false;
  messageLoading2: boolean = false;

  constructor(
    private sampleService: ChatService,
    private storageService: StorageService,
    public commonService: CommonService,
    private changeDetectorRef: ChangeDetectorRef,
    private http: HttpClient,
  ) {}

  ngOnInit(): void {
    this.baseDownloadUrl = environment.apiEndpoint;
    // this.splitingCondition();
    // this.participantList();

    // this.store.dispatch(fetchAvailableData());
    // this.availableData$ = this.store.select(selectAvailableData);
    // this.availableData$.subscribe(data => {
    //   this.filteredData = data
    // this.getSenderType();
    this.user_details = this.storageService.get('user_details');
    this.message_sender_type = this.user_details.role.group.category;
    this.profile_image =
      environment.apiEndpoint + '/' + this.user_details.profile_pic;
    // this.filteredData = this.availableData;
    // if (this.opened == false) {
    //   this.sampleService.closeDisplayChat();
    // }
  }

  messages_loaded: boolean = false;
  messages_loaded2: boolean = false;
  // openChatParticipant(advisor, event) {
  //   this.selected_advisor = advisor;
  //   const index = this.availableData.findIndex(item => item.contact_id == advisor.contact_id);
  //   if (this.openParticipants.length == 0) {
  //     this.searchAdvisor = "";
  //     this.openParticipants.push(index)
  //     this.receivedId2 = advisor.contact_id;
  //     this.participantName1 = advisor.full_name;
  //     this.last_seen1 = moment(advisor.last_seen).fromNow();
  //     this.active_now1 = advisor.active_now;
  //     this.participant_profile_picture1 = advisor.profile_pic;
  //     this.secondWindowMessages = [];
  //     this.messages_count2 = advisor.unseen_messages_count;
  //     this.messages_count2 = 0;
  //     this.currentPageNumberForWindow2 = 1;
  //     this.getMessageHistory2(this.receivedId2);
  //     this.scrollToBottom();
  //   } else if ((this.openParticipants.length == 1) && (this.openParticipants[0] == index)) {
  //     this.searchAdvisor = "";
  //     if (event && event.type == "click") {
  //       return;
  //     }
  //     this.receivedId2 = advisor.contact_id;
  //     this.participantName1 = advisor.full_name;
  //     this.last_seen1 = moment(advisor.last_seen).fromNow();
  //     this.active_now1 = advisor.active_now;
  //     this.participant_profile_picture1 = advisor.profile_pic;
  //     this.secondWindowMessages = [];
  //     this.messages_count2 = advisor.unseen_messages_count;
  //     this.messages_count2 = 0;
  //     this.currentPageNumberForWindow2 = 1;
  //     this.getMessageHistory2(this.receivedId2);
  //     this.scrollToBottom();
  //   }
  //   else if ((this.openParticipants.length == 1) && (this.openParticipants[0] != index)) {
  //     this.searchAdvisor = "";
  //     this.openParticipants.push(index);
  //     this.receivedId = this.filteredData[this.openParticipants[0]].contact_id;
  //     this.participantName = this.filteredData[this.openParticipants[0]].full_name;
  //     this.last_seen = moment(this.filteredData[this.openParticipants[0]].last_seen).fromNow();
  //     this.active_now = this.filteredData[this.openParticipants[0]].active_now;
  //     this.messages_count = this.filteredData[this.openParticipants[0]].unseen_messages_count;
  //     this.messages_count = 0;
  //     this.firstWindowMessages = [];
  //     this.participant_profile_picture = this.filteredData[this.openParticipants[0]].profile_pic;
  //     this.currentPageNumberForWindow1 = 1;
  //     this.getMessageHistory(this.receivedId);
  //     this.scrollToBottom();

  //     this.receivedId2 = advisor.contact_id;
  //     this.participantName1 = advisor.full_name;
  //     this.last_seen1 = moment(advisor.last_seen).fromNow();
  //     this.active_now1 = advisor.active_now;
  //     this.messages_count2 = advisor.unseen_messages_count;
  //     this.messages_count2 = 0;
  //     this.secondWindowMessages = [];
  //     this.participant_profile_picture1 = advisor.profile_pic;
  //     this.currentPageNumberForWindow2 = 1;
  //     this.getMessageHistory2(this.receivedId2);
  //     this.scrollToBottom();

  //     // if (this.isSearched && this.openParticipants.length == 1) {
  //     //   // Add the current advisor to the openParticipants array
  //     //   // const index = this.availableData.findIndex(item => item.contact_id == advisor.contact_id);
  //     //   this.openParticipants.push(index);
  //     //   // Update the second chat window with the new advisor
  //     //   this.receivedId2 = advisor.contact_id;
  //     //   this.participantName1 = advisor.full_name;
  //     //   this.last_seen1 = moment(advisor.last_seen).fromNow();
  //     //   this.active_now1 = advisor.active_now;
  //     //   this.participant_profile_picture1 = advisor.profile;
  //     //   this.participant_profile_picture1 = advisor.profile_pic;
  //     //   this.secondWindowMessages = [];
  //     //   this.messages_count2 = advisor.unseen_messages_count;
  //     //   this.messages_count2 = 0;
  //     //   this.currentPageNumberForWindow2 = 1;
  //     //   this.getMessageHistory2(this.receivedId2);
  //     //   this.scrollToBottom();
  //     //   // Reset isSearched to false
  //     //   this.isSearched = false;
  //     //   this.searchAdvisor = "";
  //     // } else {
  //     //   this.receivedId2 = advisor.contact_id;
  //     //   this.participantName1 = advisor.full_name;
  //     //   this.last_seen1 = moment(advisor.last_seen).fromNow();
  //     //   this.active_now1 = advisor.active_now;
  //     //   this.participant_profile_picture1 = advisor.profile_pic;
  //     //   this.secondWindowMessages = [];
  //     //   this.messages_count2 = advisor.unseen_messages_count;
  //     //   this.messages_count2 = 0;
  //     //   this.currentPageNumberForWindow2 = 1;
  //     //   this.getMessageHistory2(this.receivedId2);
  //     //   this.scrollToBottom();
  //     // }
  //   }
  //   else if ((this.openParticipants[0] != index) && (this.openParticipants[1] != index)) {
  //     // Store the data of the first window temporarily
  //     const tempReceivedId = this.receivedId;
  //     const tempParticipantName = this.participantName;
  //     const tempLastSeen = this.last_seen;
  //     const tempActiveNow = this.active_now;
  //     const tempProfilePic = this.participant_profile_picture;
  //     const tempMessagesCount = this.messages_count;

  //     // Copy the data from the second window to the first window
  //     this.receivedId = this.receivedId2;
  //     this.participantName = this.participantName1;
  //     this.last_seen = this.last_seen1;
  //     this.active_now = this.active_now1;
  //     this.participant_profile_picture = this.participant_profile_picture1;
  //     this.messages_count = this.messages_count2;
  //     this.firstWindowMessages = this.secondWindowMessages.slice();
  //     this.currentPageNumberForWindow1 = this.currentPageNumberForWindow2;
  //     this.getMessageHistory(this.receivedId);
  //     this.scrollToBottom();

  //     // Copy the data from the temporary variables (originally the first window) to the second window
  //     this.receivedId2 = tempReceivedId;
  //     this.participantName1 = tempParticipantName;
  //     this.last_seen1 = tempLastSeen;
  //     this.active_now1 = tempActiveNow;
  //     this.participant_profile_picture1 = tempProfilePic;
  //     this.messages_count2 = tempMessagesCount;
  //     this.secondWindowMessages = this.firstWindowMessages.slice();
  //     this.currentPageNumberForWindow2 = this.currentPageNumberForWindow1;
  //     this.getMessageHistory2(this.receivedId2);
  //     this.scrollToBottom();

  //     // Add the new advisor to the second window
  //     this.openParticipants[1] = index;
  //     this.receivedId2 = advisor.contact_id;
  //     this.participantName1 = advisor.full_name;
  //     this.last_seen1 = moment(advisor.last_seen).fromNow();
  //     this.active_now1 = advisor.active_now;
  //     this.participant_profile_picture1 = advisor.profile_pic;
  //     this.secondWindowMessages = [];
  //     this.messages_count2 = advisor.unseen_messages_count;
  //     this.messages_count2 = 0;
  //     this.currentPageNumberForWindow2 = 1;
  //     this.getMessageHistory2(this.receivedId2);
  //     this.scrollToBottom();
  //     this.searchAdvisor = "";
  //   }
  // }

  openChatParticipant(advisor, event) {
    // this.availableData = this.filteredData;

    const index = this.availableData.findIndex(
      (item) => item.contact_id === advisor.contact_id,
    );
    this.searchAdvisor = '';
    if (this.openParticipants.length === 0) {
      this.openParticipants.push(index);
      this.loadAdvisorDataWindow2(advisor);
    } else if (this.openParticipants.length === 1) {
      if (this.openParticipants[0] === index) {
        if (event && event.type === 'click') {
          return;
        }
        this.loadAdvisorDataWindow2(advisor);
      } else {
        this.openParticipants.push(index);
        this.loadAdvisorDataWindow1(
          this.availableData[this.openParticipants[0]],
        );
        this.loadAdvisorDataWindow2(advisor);
      }
    } else {
      if (
        this.openParticipants[0] !== index &&
        this.openParticipants[1] !== index
      ) {
        this.openParticipants[0] = this.openParticipants[1];
        this.openParticipants[1] = index;
        this.loadAdvisorDataWindow1(
          this.availableData[this.openParticipants[0]],
        );
        this.loadAdvisorDataWindow2(advisor);
      }
    }
  }

  loadAdvisorDataWindow1(advisor) {
    this.receivedId = advisor.contact_id;
    this.participantName = advisor.full_name;
    this.last_seen = moment(advisor.last_seen).fromNow();
    this.active_now = advisor.active_now;
    this.participant_profile_picture = advisor.profile_pic;
    // this.messages_count = 0;
    this.currentPageNumberForWindow1 = 1;
    this.participant_window = true;
    this.getMessageHistory(this.receivedId);
    // advisor.unseen_messages_count = 0;
    // this.filteredData[index].unseen_messages_count = 0;
    // this.messages_count = advisor.unseen_messages_count;
    this.scrollToBottom();
  }

  // loadAdvisorDataWindow2(advisor) {
  //   this.receivedId2 = advisor.contact_id;
  //   this.participantName1 = advisor.full_name;
  //   this.last_seen1 = moment(advisor.last_seen).fromNow();
  //   this.active_now1 = advisor.active_now;
  //   this.participant_profile_picture1 = advisor.profile_pic;
  //   // this.messages_count2 = 0;
  //   this.currentPageNumberForWindow2 = 1;
  //   this.participant_window2 = true;
  //   this.getMessageHistory2(this.receivedId2);
  //   // advisor.unseen_messages_count = 0;
  //   // this.filteredData[index].unseen_messages_count = 0;
  //   // this.messages_count2 = advisor.unseen_messages_count;
  //   this.scrollToBottom();
  // }

  loadAdvisorDataWindow2(advisor) {
    this.receivedId2 = advisor.contact_id;
    this.participantName1 = advisor.full_name;
    this.last_seen1 = moment(advisor.last_seen).fromNow();
    this.active_now1 = advisor.active_now;
    this.participant_profile_picture1 = advisor.profile_pic;
    // this.messages_count2 = 0;
    this.currentPageNumberForWindow2 = 1;
    this.participant_window = false;
    this.participant_window2 = true;
    this.getMessageHistory2(this.receivedId2);
    // advisor.unseen_messages_count = 0;
    // this.filteredData[index].unseen_messages_count = 0;
    // this.messages_count2 = advisor.unseen_messages_count;
    this.scrollToBottom();
  }

  @ViewChildren('message_container') containers: QueryList<ElementRef>;
  scrollToBottom(): void {
    setTimeout(() => {
      this.containers.forEach((container: ElementRef) => {
        container.nativeElement.scrollTop =
          container.nativeElement.scrollHeight;
      });
    }, 0);
    // this.messages_count = 0;
    // this.messages_count2 = 0;
  }

  @HostListener('scroll', ['$event']) container: ElementRef;
  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    this.scroll_page_window1 = element.scrollTop;

    if (element.scrollTop == 0) {
      if (this.currentPageNumberForWindow1 <= this.no_of_pages) {
        this.currentPageNumberForWindow1 += 1;
      }

      if (this.currentPageNumberForWindow1 == this.no_of_pages) {
        this.messageLoading = false;
      }

      // Save the current scroll height before loading new messages
      const previousScrollHeight = element.scrollHeight;

      // Create a MutationObserver to watch for changes in the chat container
      const observer = new MutationObserver(() => {
        // Adjust the scroll position to maintain the same place
        const newScrollHeight = element.scrollHeight;
        element.scrollTop = newScrollHeight - previousScrollHeight;

        // Disconnect the observer after adjusting the scroll position
        observer.disconnect();
      });

      // Configure the observer to watch for childList changes in the chat container
      const config = { childList: true };
      observer.observe(element, config);
      // Load new messages
      this.getMessageHistory(this.receivedId);

      setTimeout(() => {
        this.messageLoading = true;
        if (this.currentPageNumberForWindow1 >= this.no_of_pages) {
          this.messageLoading = false;
        }
      }, 1000);
    }
  }

  @HostListener('scroll', ['$event']) container2: ElementRef;
  onScroll2(event: Event) {
    const element = event.target as HTMLElement;
    if (element.scrollTop == 0) {
      if (this.currentPageNumberForWindow2 <= this.no_of_pages2) {
        this.currentPageNumberForWindow2 += 1;
        this.messageLoading2 = false;
      }
      // Save the current scroll height before loading new messages
      const previousScrollHeight = element.scrollHeight;

      // Create a MutationObserver to watch for changes in the chat container
      const observer = new MutationObserver(() => {
        // Store the current scroll position
        const newScrollHeight = element.scrollHeight;

        // Adjust the scroll position to maintain the same place
        element.scrollTop = newScrollHeight - previousScrollHeight;
        // Disconnect the observer after adjusting the scroll position
        observer.disconnect();
      });

      // Configure the observer to watch for childList changes in the chat container
      const config = { childList: true };
      observer.observe(element, config);
      this.messageLoading2 = false;
      this.getMessageHistory2(this.receivedId2);

      setTimeout(() => {
        this.messageLoading2 = true;
        if (this.currentPageNumberForWindow2 >= this.no_of_pages2) {
          this.messageLoading2 = false;
        }
      }, 1000);

      // this.previousScrollHeight2= element.scrollTop;
      if (this.currentPageNumberForWindow1 > this.no_of_pages)
        this.messageLoading2 = false;
    }
  }

  last_message: any;
  no_of_pages: any;
  getMessageHistory(received_id) {
    this.receivedId = received_id;
    this.baseDownloadUrl = environment.apiEndpoint;
    let page = this.currentPageNumberForWindow1;
    if (page == 1) {
      this.firstWindowMessages = [];
      this.fetchedMessages = [];
    }
    this.subscription1 = this.sampleService
      .getMessageHistory(received_id, page)
      .subscribe((data: any) => {
        this.no_of_pages = data.no_of_pages;
        if (data.data.length > 0) {
          // Reverse the messages to keep the correct order when using unshift
          data.data.forEach((element) => {
            if (element.id !== this.last_message) {
              if (
                element.sender === this.receivedId ||
                element.receiver === this.receivedId
              ) {
                this.fetchedMessages.push(element);
                this.last_message = element.id;
              }
            }
          });
          this.firstWindowMessages = this.fetchedMessages;
          if (page > 1) {
            const reversedMessages = data.data;
            this.firstWindowMessages = [
              ...this.firstWindowMessages,
              ...reversedMessages,
            ];
            const uniqueMessages = {};
            this.firstWindowMessages = this.firstWindowMessages.filter(
              (message) => {
                if (!uniqueMessages[message.id]) {
                  uniqueMessages[message.id] = true;
                  return true;
                }
                return false;
              },
            );
          }
          this.firstWindowMessages.sort((a, b) => {
            return a.id - b.id;
          });

          this.firstWindowMessages = [...new Set(this.firstWindowMessages)];
        }

        let timestamps1 = [];
        let prevTimestamp1 = null;

        for (let i = 0; i < this.firstWindowMessages.length; i++) {
          let message = this.firstWindowMessages[i];
          let timestamp1 = message.timestamp;

          // Check if the timestamp has changed
          if (timestamp1 !== prevTimestamp1) {
            timestamps1.push(timestamp1);
            prevTimestamp1 = timestamp1;
          }
          // Remove the timestamp from the message object
          // delete message.timestamp;
        }
        // timestamps.slice(-1,0);
        let momentTimeStamp1 = [];
        for (let f = 0; f < timestamps1.length; f++) {
          let momenttedStamps = moment(timestamps1[f]).format('Do MMMM YYYY');
          momentTimeStamp1.push(momenttedStamps);
        }
        // The reduced object without timestamps
        this.messages_loaded = true;
        // this.fetchedMessages.push();
        let previousTimestamp1: string | undefined = undefined;

        for (const timestamp of momentTimeStamp1) {
          if (timestamp !== previousTimestamp1) {
            this.show_timestamp.push(timestamp);
            previousTimestamp1 = timestamp;
          }
        }
        function isFirstOccurrence(arr: string[], str: string): boolean[] {
          const indexMap: { [key: string]: number } = {};
          return arr.map((item) => {
            if (indexMap[item]) {
              return false;
            } else if (item === str) {
              indexMap[item] = 1;
              return true;
            } else {
              return false;
            }
          });
        }
        this.show_different_dates = [];
        for (let i = 0; i < this.show_timestamp.length; i++) {
          const isFirst = isFirstOccurrence(
            momentTimeStamp1,
            this.show_timestamp[i],
          );
          this.show_different_dates.push(isFirst);
        }
        const reduceArr = this.show_different_dates.reduce((acc, arr) => {
          arr.forEach((val, i) => {
            if (val) {
              acc[i] = true;
            }
          });
          return acc;
        }, Array(this.show_different_dates[0].length).fill(false));

        reduceArr[0] = true;

        for (let i = 0; i < this.firstWindowMessages.length; i++) {
          this.firstWindowMessages[i]['show_timestamp'] = reduceArr[i];
        }
        // this.participantList();
        if (this.currentPageNumberForWindow1 == 1) {
          this.scrollToBottom();
        }
      });
    this.messages_count = 0;
  }

  last_message2: any;
  no_of_pages2: any;
  getMessageHistory2(received_id) {
    this.receivedId2 = received_id;

    this.baseDownloadUrl = environment.apiEndpoint;
    let page = this.currentPageNumberForWindow2;
    if (page == 1) {
      this.secondWindowMessages = [];
      this.fetchedMessages2 = [];
    }
    // const messageExists = (msgId: number, messages: any[]): boolean => {
    //   return messages.some((msg) => msg.id === msgId);
    // };
    this.subscription2 = this.sampleService
      .getMessageHistory2(received_id, page)
      .subscribe((res: any) => {
        this.no_of_pages2 = res.no_of_pages;
        if (res.data.length > 0) {
          res.data.forEach((element) => {
            if (element.id !== this.last_message2) {
              if (
                element.sender === this.receivedId2 ||
                element.receiver === this.receivedId2
              ) {
                this.fetchedMessages2.push(element);
                this.last_message2 = element.id;
              }
            }
          });
          this.secondWindowMessages = this.fetchedMessages2;
          if (page > 1) {
            const reversedMessages = res.data;
            this.secondWindowMessages = [
              ...this.secondWindowMessages,
              ...reversedMessages,
            ];
            const uniqueMessages = {};
            this.secondWindowMessages = this.secondWindowMessages.filter(
              (message) => {
                if (!uniqueMessages[message.id]) {
                  uniqueMessages[message.id] = true;
                  return true;
                }
                return false;
              },
            );
          }
          this.secondWindowMessages.sort((a, b) => {
            return a.id - b.id;
          });

          this.secondWindowMessages = [...new Set(this.secondWindowMessages)];
        }

        let timestamps2 = [];
        let prevTimestamp2 = null;
        for (let i = 0; i < this.secondWindowMessages.length; i++) {
          let message = this.secondWindowMessages[i];
          let timestamp2 = message.timestamp;
          // Check if the timestamp has changed
          if (timestamp2 !== prevTimestamp2) {
            timestamps2.push(timestamp2);
            prevTimestamp2 = timestamp2;
          }
          // Remove the timestamp from the message object
          // delete message.timestamp;
        }
        // timestamps.slice(-1,0);
        let momentTimeStamp2 = [];
        for (let f = 0; f < timestamps2.length; f++) {
          let momenttedStamps = moment(timestamps2[f]).format('Do MMMM YYYY');
          momentTimeStamp2.push(momenttedStamps);
        }
        // The reduced object without timestamps
        this.messages_loaded2 = true;
        // this.fetchedMessages2.push();
        let previousTimestamp2: string | undefined = undefined;

        for (const timestamp of momentTimeStamp2) {
          if (timestamp !== previousTimestamp2) {
            this.show_timestamp2.push(timestamp);
            previousTimestamp2 = timestamp;
          }
        }
        function isFirstOccurrence(arr: string[], str: string): boolean[] {
          const indexMap: { [key: string]: number } = {};
          return arr.map((item) => {
            if (indexMap[item]) {
              return false;
            } else if (item === str) {
              indexMap[item] = 1;
              return true;
            } else {
              return false;
            }
          });
        }
        this.show_different_dates2 = [];
        for (let i = 0; i < this.show_timestamp2.length; i++) {
          const isFirst = isFirstOccurrence(
            momentTimeStamp2,
            this.show_timestamp2[i],
          );
          this.show_different_dates2.push(isFirst);
        }
        if (this.show_different_dates2.length > 0) {
          const reduceArr2 = this.show_different_dates2.reduce((acc, arr) => {
            arr.forEach((val, i) => {
              if (val) {
                acc[i] = true;
              }
            });
            return acc;
          }, Array(this.show_different_dates2[0].length).fill(false));

          reduceArr2[0] = true;

          for (let i = 0; i < this.secondWindowMessages.length; i++) {
            this.secondWindowMessages[i]['show_timestamp'] = reduceArr2[i];
          }
        }

        // this.participantList();

        if (this.currentPageNumberForWindow2 == 1) {
          this.scrollToBottom();
        }
      });
    this.messages_count2 = 0;
  }

  // interval_id:any = 0;

  openChatWindow() {
    this.loading = true;
    this.participantList();
    this.opened = !this.opened;
    if (this.opened == false) {
      this.sampleService.closeDisplayChat();
      // this.chatSubscription.unsubscribe();
      // clearInterval(this.interval_id);
    }
    // else{
    //   this.interval_id = setInterval(() => {
    //     this.participantList();
    //   }, 60000);
    // }
  }
  getSenderType() {
    this.message_sender_type = this.sampleService.assigningRole();

    return this.message_sender_type;
  }

  sendMsg() {
    let data1 = {
      command: '',
      message: '',
      category: '',
    };
    data1.command = 'new_message';
    data1.message = this.content;
    data1.category = this.message_sender_type;
    this.sampleService.sendMessage(data1);
    this.content = '';
    this.participantList();
    this.scrollToBottom();
  }

  sendMsg2() {
    let data2 = {
      command: '',
      message: '',
      category: '',
    };
    data2.command = 'new_message';
    data2.message = this.content2;
    data2.category = this.message_sender_type;

    this.sampleService.sendMessage2(data2);
    this.content2 = '';
    this.scrollToBottom();
    this.participantList();
  }

  // closeChat2() {
  //   this.currentPageNumberForWindow2 = 1;

  //   if (this.openParticipants.length === 1) {
  //     this.messages_loaded2 = !this.messages_loaded2;
  //     this.subscription2.unsubscribe();
  //     this.sampleService.closeConnection2();
  //     this.openParticipants = [];
  //     this.secondWindowMessages = [];
  //   }
  //   else if (this.openParticipants.length >= 2) {
  //     const firstParticipantIndex = this.openParticipants[0];
  //     const secondParticipantIndex = this.openParticipants[1];

  //     // Close the second chat window
  //     this.openParticipants.splice(1, 1);
  //     this.secondWindowMessages = [];

  //     // Load the first chat window content into the second chat window
  //     const firstParticipant = this.availableData[firstParticipantIndex];
  //     this.openChatParticipant(firstParticipant, null);

  //     // If there are more than 2 open chats, shift the rest of the chats one position to the left
  //     if (this.openParticipants.length > 1) {
  //       for (let i = 1; i < this.openParticipants.length; i++) {
  //         this.openParticipants[i - 1] = this.openParticipants[i];
  //       }
  //       this.openParticipants.pop(); // Remove the last chat
  //     }
  //   }
  //   this.scrollToBottom();
  // }

  closeChat2() {
    if (this.openParticipants.length == 1) {
      this.messages_loaded2 = !this.messages_loaded2;
      this.receivedId2 = null;
      this.subscription2.unsubscribe();
      this.sampleService.closeConnection2();
      this.openParticipants = [];
      this.secondWindowMessages = [];
    } else if (this.openParticipants.length === 2) {
      this.openParticipants.pop();
      this.receivedId2 = null;
      this.secondWindowMessages = [];
      this.loadAdvisorDataWindow2(this.availableData[this.openParticipants[0]]);
    }
    this.participantList();
    this.changeDetectorRef.detectChanges();
  }

  closeChat() {
    this.messages_loaded = !this.messages_loaded;
    this.receivedId = null;
    this.openParticipants.splice(0, 1);
    this.subscription1.unsubscribe();
    this.sampleService.closeConnection();
    this.scrollToBottom();
    setTimeout(() => {
      this.participantList();
    }, 100);
    this.changeDetectorRef.detectChanges();
  }

  participantList() {
    // this.loading = true;
    // setTimeout(() => {

    this.chatSubscription = this.sampleService.displayChat().subscribe(
      (data: any) => {
        this.loading = false;
        this.availableData = data.data;
        this.searchAdvisorList = this.availableData;
        this.filteredData = this.availableData;
        for (let i = 0; i < this.filteredData.length; i++) {
          if (
            this.filteredData[i].contact_id == this.receivedId &&
            this.participant_window
          ) {
            this.filteredData[i].unseen_messages_count = 0;
          }
          if (
            this.filteredData[i].contact_id == this.receivedId2 &&
            this.participant_window2
          ) {
            this.filteredData[i].unseen_messages_count = 0;
          }
        }
      },
      (error) => {
        this.commonService.showToast(
          'error while connecting to internet',
          error,
        );
      },
    );
    this.changeDetectorRef.detectChanges();
    // }, 120000);
  }

  shouldShowUnseenMessages(advisor) {
    if (advisor.contact_id === this.receivedId && this.messages_loaded) {
      return false;
    }
    if (advisor.contact_id === this.receivedId2 && this.messages_loaded2) {
      return false;
    }
    return true;
  }

  // searchAdvisors() {
  //   this.loading = true;
  //   this.isSearched = true;
  //   setTimeout(() => {
  //     this.loading = false;
  //     if (this.searchAdvisor === "") {
  //       this.filteredData = this.availableData$;
  //     } else {
  //       this.searchAdvisorList = this.filteredData.filter((item) => {
  //         return item.full_name.toLowerCase().includes(this.searchAdvisor.toLowerCase());
  //       });
  //       this.filteredData = this.searchAdvisorList;
  //     }
  //   }, 100);

  // }

  searchAdvisors() {
    if (this.searchAdvisor === '') {
      this.filteredData = this.availableData;
    } else {
      this.searchAdvisorList = this.filteredData.filter((item) => {
        return item.full_name
          .toLowerCase()
          .includes(this.searchAdvisor.toLowerCase());
      });
      this.filteredData = this.searchAdvisorList;
    }
  }

  keyDownEvent(event) {
    if (event.keyCode == 13) {
      this.sendMsg();
    }
  }

  @ViewChild('upload_document_file') upload_document_file: ElementRef;
  sendDocFile(event) {
    this.selected_doc_type.file = event.target.files[0];
    this.selected_doc_type.file_name = event.target.files[0].name;
    let formData = new FormData();
    formData.append('document', this.selected_doc_type.file);
    let doc_url = environment.apiEndpoint + '/chat/media/';
    this.http.post(doc_url, formData).subscribe((res: any) => {
      this.media_id = res.data.media_id;
      this.sendFiles();
    });
    // this.commonService.showToast('success', 'successfully uploaded file');
  }

  @ViewChild('upload_video_file') upload_video_file: ElementRef;
  sendVideoFile(event) {
    this.selected_doc_type.file = event.target.files[0];
    this.selected_doc_type.file_name = event.target.files[0].name;
    let formData = new FormData();
    formData.append('chat_video', this.selected_doc_type.file);
    let video_url = environment.apiEndpoint + '/chat/media/';
    this.http.post(video_url, formData).subscribe((res: any) => {
      this.media_id = res.data.media_id;
      this.sendFiles();
    });
    // this.commonService.showToast('success', 'successfully uploaded file');
  }

  @ViewChild('upload_picture_file') upload_picture_file: ElementRef;
  sendPicFile(event) {
    this.selected_doc_type.file = event.target.files[0];
    this.selected_doc_type.file_name = event.target.files[0].name;
    let formData = new FormData();
    formData.append('chat_pic', this.selected_doc_type.file);
    let image_url = environment.apiEndpoint + '/chat/media/';
    this.http.post(image_url, formData).subscribe((res: any) => {
      this.media_id = res.data.media_id;
      this.sendFiles();
    });
    // this.commonService.showToast('success', 'successfully uploaded file');
  }

  @ViewChild('upload_document_file2') upload_document_file2: ElementRef;
  sendDocFile2(event) {
    this.selected_doc_type.file = event.target.files[0];
    this.selected_doc_type.file_name = event.target.files[0].name;
    let formData = new FormData();
    formData.append('document', this.selected_doc_type.file);
    let doc_url = environment.apiEndpoint + '/chat/media/';
    this.http.post(doc_url, formData).subscribe((res: any) => {
      this.media_id = res.data.media_id;
      this.sendFiles2();
    });
    // this.commonService.showToast('success', 'successfully uploaded file');
  }

  @ViewChild('upload_video_file2') upload_video_file2: ElementRef;
  sendVideoFile2(event) {
    this.selected_doc_type.file = event.target.files[0];
    this.selected_doc_type.file_name = event.target.files[0].name;
    let formData = new FormData();
    formData.append('chat_video', this.selected_doc_type.file);
    let video_url = environment.apiEndpoint + '/chat/media/';
    this.http.post(video_url, formData).subscribe((res: any) => {
      this.media_id = res.data.media_id;
      this.sendFiles2();
    });
    // this.commonService.showToast('success', 'successfully uploaded file');
  }

  @ViewChild('upload_picture_file2') upload_picture_file2: ElementRef;
  sendPicFile2(event) {
    this.selected_doc_type.file = event.target.files[0];
    this.selected_doc_type.file_name = event.target.files[0].name;
    let formData = new FormData();
    formData.append('chat_pic', this.selected_doc_type.file);
    let image_url = environment.apiEndpoint + '/chat/media/';
    this.http.post(image_url, formData).subscribe((res: any) => {
      this.media_id = res.data.media_id;
      this.sendFiles2();
    });
    // this.commonService.showToast('success', 'successfully uploaded file');
  }

  sendFiles() {
    let data = {
      command: '',
      media_id: '',
      category: '',
    };
    data.command = 'new_message';
    data.media_id = this.media_id;
    data.category = this.message_sender_type;
    // if (this.availableData[this.openParticipants[0]] == this.receivedId) {
    //   this.sampleService.sendMessage(data);
    // }
    this.sampleService.sendMessage(data);
    this.participantList();
    this.media_id = '';
  }

  sendFiles2() {
    let data = {
      command: '',
      media_id: '',
      category: '',
    };
    data.command = 'new_message';
    data.media_id = this.media_id;
    data.category = this.message_sender_type;
    // if (this.availableData[this.openParticipants[1]] == this.receivedId2) {
    //   // this.sampleService.sendMessage(data);
    // }
    this.sampleService.sendMessage2(data);
    this.participantList();
    this.media_id = '';
  }

  openParticipantWindow() {
    this.scrollToBottom();
    this.participant_window = !this.participant_window;
    this.sampleService.closeConnection();
    this.getMessageHistory(this.receivedId);
    this.participantList();
  }

  openParticipantWindow2() {
    this.scrollToBottom();
    this.participant_window2 = !this.participant_window2;
    this.sampleService.closeConnection2();
    this.getMessageHistory2(this.receivedId2);
    this.participantList();
  }

  splitDocument(element) {
    let docuName = element.split('__');
    return docuName[1];
  }

  ngOnDestroy() {
    if (this.chatSubscription) {
      this.chatSubscription.unsubscribe();
    }
  }

  splitingCondition() {
    const operators = [0, 1];
    operators.splice(1, 1);
  }

  download(url, link) {
    const file = url + '/' + link;
    window.open(file, '_blank');
  }
}
